import { PaymentMethodCode } from '@backmarket/http-api/src/api-specs-payment/payment/payment.types'

export const MODAL_NAMES = {
  GIFT_CARDS_FAQ: 'GIFT_CARDS_FAQ',
}
export const GIFT_CARDS_PAYMENT_METHOD = [PaymentMethodCode.CARD]

// TODO: fech from the API when avaible on backend
export const GIFT_CARD_BILLABLE_COUNTRIES = [
  {
    name: 'United States',
    countryCode: 'US',
  },
  {
    name: 'France',
    countryCode: 'FR',
  },
  {
    name: 'Germany',
    countryCode: 'DE',
  },
  {
    name: 'Spain',
    countryCode: 'ES',
  },
  {
    name: 'United Kingdom',
    countryCode: 'GB',
  },
]
